import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table'
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { forEach } from 'lodash';
import {
    ColumnType,
} from '../../../shared/components/table-settings/table-settings.component';

// Services
import { SharedService } from '../../../layouts/shared-service';
import { MatTable } from '@angular/material/table';


const initialColumns: ColumnType[] = [
    {
        id: 'select',
        name: 'Select',
    },
    {
        id: 'customer',
        name: 'Customer'
    }
];

@Component({
    selector: 'app-group-analytics-generate-dialog-grid',
    styleUrls: ['./group-analytics-generate-dialog-grid.component.scss'],
    templateUrl: './group-analytics-generate-dialog-grid.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupAnalyticsGenerateDialogGridComponent implements OnInit {
    @Input() groupDistributionData: any[];
    @Input() groupDistributionGridData: any[];
    @Output() customerSelectedClicked = new EventEmitter<any>();
    @Output() selectAllClicked = new EventEmitter<any>();
    @Output() manuallyCheckedChanged = new EventEmitter<Set<number>>();
    @ViewChild(MatTable) table!: MatTable<any>;

    groupDistributionDataSource: any = null;
    columns: ColumnType[] = [];

    selectAll = false;
    public manuallyCheckedCustomers = new Set<number>();

    constructor(private router: Router, private sharedService: SharedService) {

    }

    ngOnInit() {
        this.columns = initialColumns;

        this.refreshGroupDistributionDataSource();
    }

    ngOnDestroy() {
        forEach(this.groupDistributionDataSource.data, (customer) => {
            if (customer.checked)
                customer.checked = false;
        });
    }

    getTableColumns() {
        return this.columns
            .filter((column) => !column.hidden)
            .map((column) => column.id);
    }

    selectAllChanged(event: any) {
        this.selectAllClicked.emit(event.checked);
    }

    updateSelectAll(customers) {
        const selectedCount = customers.filter(c => c.checked == true).length;
        const totalItems = customers.length;

        if (selectedCount === totalItems) {
            this.selectAll = true;
        } else if (selectedCount > 0) {
            this.selectAll = false;
        } else {
            this.selectAll = false;
        }
    }

    public customerSelectedRow(customer) {
        if (customer.checked == null)
            customer.checked = true;
        else
            customer.checked = !customer.checked;

        this.customerSelected(customer);
    }

    public customerSelected(customer: any) {
        this.customerSelectedClicked.emit(customer);
    }

    applyFilter(filter: string) {
        this.groupDistributionDataSource.filter = filter.trim().toLowerCase();
    }

    // Function to determine if "Select All" checkbox should be indeterminate
    public isIndeterminate(): boolean {
        var selectedCount;
        var totalItems;
        if (this.groupDistributionDataSource.filter && this.groupDistributionDataSource.filter != "") {
            selectedCount = this.groupDistributionDataSource.filteredData.filter((customer) => customer.checked).length;
            totalItems = this.groupDistributionDataSource.filteredData.length;
        }
        else {
            selectedCount = this.groupDistributionDataSource.data.filter((customer) => customer.checked).length;
            totalItems = this.groupDistributionDataSource.data.length;
        }

        if (selectedCount == totalItems)
            this.selectAll = true;
        else if (selectedCount == 0)
            this.selectAll = false;
        else
            return selectedCount > 0 && selectedCount < totalItems;
    }

    public refreshGroupDistributionDataSource() {
        if (!this.groupDistributionDataSource) {
            this.groupDistributionDataSource = new MatTableDataSource();
        }

        // Re-assign with a new array reference to trigger change detection
        this.groupDistributionDataSource.data = [...this.groupDistributionGridData];
        this.table?.renderRows();

        this.groupDistributionDataSource.filterPredicate = (data: Element, filter: string) => {
            return data['company'].toLowerCase().startsWith(filter.toLowerCase());
        };
    }
}
